<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1 ziro-report-content">
    <router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
